import React from "react";
import {
  CloudArrowUpIcon,
  CloudArrowDownIcon,
  ArrowUpTrayIcon,
  ArrowPathIcon
} from "@heroicons/react/24/outline";

const TableToolbar = ({
  pendingChanges,
  isSaving,
  isDownloading,
  isUploading,
  isRefreshingData,
  statementId,
  onSave,
  onDownloadOriginal,
  onUpload,
  onRefresh,
  fileInputRef
}) => {
  return (
    <div className="fixed top-16 right-4 z-10 flex gap-2 items-center">
      {/* Save Changes Button */}
      <button
        onClick={onSave}
        disabled={!statementId || isSaving}
        className={`relative flex items-center justify-center w-10 h-10 rounded-lg shadow transition-all duration-200 ${
          !isSaving
            ? pendingChanges > 0 
              ? 'bg-green-600 text-white hover:bg-green-700 hover:shadow-lg hover:scale-105' 
              : 'bg-gray-300 text-gray-600 hover:bg-gray-400'
            : 'bg-blue-600 text-white cursor-wait'
        }`}
        title={
          isSaving ? 'Saving...' : 
          pendingChanges > 0 ? `Save ${pendingChanges} change(s)` : 
          'No changes to save'
        }
      >
        <CloudArrowUpIcon className="h-5 w-5" />
        {pendingChanges > 0 && !isSaving && (
          <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs w-5 h-5 rounded-full flex items-center justify-center">
            {pendingChanges}
          </span>
        )}
        {isSaving && (
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
          </div>
        )}
      </button>
      
      {/* Download Original Excel Button */}
      <button
        onClick={onDownloadOriginal}
        disabled={isDownloading || !statementId}
        className={`flex items-center justify-center w-10 h-10 rounded-lg shadow transition-all duration-200 ${
          statementId && !isDownloading
            ? 'bg-green-600 text-white hover:bg-green-700 hover:shadow-lg hover:scale-105'
            : 'bg-gray-200 text-gray-500 cursor-not-allowed'
        }`}
        title={isDownloading ? 'Downloading...' : 'Download Original Excel from Server'}
      >
        <CloudArrowDownIcon className="h-5 w-5" />
      </button>
      
      {/* Upload Excel Button */}
      <button
        onClick={onUpload}
        disabled={isUploading || !statementId}
        className={`flex items-center justify-center w-10 h-10 rounded-lg shadow transition-all duration-200 ${
          statementId && !isUploading
            ? 'bg-amber-600 text-white hover:bg-amber-700 hover:shadow-lg hover:scale-105'
            : 'bg-gray-200 text-gray-500 cursor-not-allowed'
        }`}
        title={isUploading ? 'Uploading...' : 'Upload Updated Excel'}
      >
        <ArrowUpTrayIcon className="h-5 w-5" />
      </button>

      {/* Refresh Button */}
      <button
        onClick={onRefresh}
        disabled={isRefreshingData || !statementId}
        className={`flex items-center justify-center w-10 h-10 rounded-lg shadow transition-all duration-200 ${
          statementId && !isRefreshingData
            ? 'bg-indigo-600 text-white hover:bg-indigo-700 hover:shadow-lg hover:scale-105'
            : 'bg-gray-200 text-gray-500 cursor-not-allowed'
        }`}
        title={isRefreshingData ? 'Refreshing...' : 'Refresh Table Data'}
      >
        <ArrowPathIcon className={`h-5 w-5 ${isRefreshingData ? 'animate-spin' : ''}`} />
      </button>
      
      {/* Hidden file input for upload */}
      <input
        type="file"
        ref={fileInputRef}
        className="hidden"
        accept=".xlsx,.xls"
        onChange={onUpload}
      />
    </div>
  );
};

export default TableToolbar;
